import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import PeopleIcon from '@mui/icons-material/People';
import Search from '@mui/icons-material/Search';
import { Button, Card, CardContent, CircularProgress, Container, CssBaseline, Grid, Pagination, TextField, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import FirstElement from '../../components/first-element';
import Footer from '../../components/footer';
import HeaderMenu from '../../components/header-menu';
import CustomizedSnackbars from '../../components/material-snackbars';
import SimpleSelect from '../../components/select/simple-search';
import MyMaterialTable from '../../components/table';
import { AbilityContext } from '../../config/ability-context';
import * as componentActions from '../../redux/actions/customers';
import Api from '../../services/api';
import Api2Talk from "../../services/api2talk";
import { Overlay } from '../../styles/global';
import { Styles } from '../../styles/material-styles';

class CustomerList extends Component {

    constructor(props) {
        super(props);

        this.typingTimeout = null;
        this.emptyArray = null;

        const filters = [
            { id: "name", name:"Nome"},
            { id: "email", name:"E-mail"},
            { id: "phone", name:"Telefone"},
        ];

        this.state = {
            dataFilter: false,
            loading: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            resultList: [],
            totalPages:0,
            page:1,
            pageStart:0,
            pageEnd:0,
            count:0,
            searchValue: '',
            filterSelected: 0,
            filters
        };

        this.callSearch = this.callSearch.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.closeNotification = this.closeNotification.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.clearFields = this.clearFields.bind(this);
    }

    onChangePaginate = (e,page) =>{
        this.setState({ page:page });
        this.getItens(page);
    }

    setPagination(count,page){              
        let totalPage = Math.ceil (count/10);
        this.setState({ totalPages:totalPage })
        if(count > 0){
            if(page == 1){
                this.setState({pageStart:1,pageEnd:10});
            } else{
                let pageStart = ((page - 1) * 10) + 1;
                if(count >= page * 10){
                    this.setState({pageStart:pageStart,pageEnd:page * 10});
                } else{
                    this.setState({pageStart:pageStart,pageEnd:count});
                }
            }
        } else {
            this.setState({totalPages:0,page:1,count:0});
        }                   
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.location.state === "reload"){
            this.componentDidMount();
        }
    }    

    componentDidMount() {
        this.getItens();
    }

    fetchDataNotSuccess(result) {
        const intl = this.props.intl;
        this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: result.data &&  result.data.errors && result.data.errors[0] ? result.data.errors[0] : intl.formatMessage({id:"process.error"})
        });
    }

    fetchDataThrowError(err) {
        const intl = this.props.intl;
        this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({id:"process.error"})
        });
    }

    async getItens(page = 1) {
        this.setState({ loading: true });

        let url = `/customer/paginate?page=${page}`;

        if (this.state.searchValue != '' && this.state.filterSelected) {
            url += `&search=${this.state.searchValue}&field=${this.state.filterSelected}`
        }
        
        Api2Talk.get(url)
            .then(result => {
                this.setState({ loading: false });
                if (result.data.success) {
                    this.emptyArray = (result.data.data.length === 0) ? true : false ;
                    const count = result.data.count;
                    this.setState({count});
                    this.setPagination(count,page);
                    const formattedList = result.data.data.map(item => {
                        return {...item}
                    });
                    this.setState({ loading: false, resultList: formattedList });
                } else {
                    this.fetchDataNotSuccess(result);
                    Api.kickoff(result);
                }
            })
            .catch(err => {
                this.setState({ loading: false });
                this.fetchDataThrowError(err)
                Api.kickoff(err);
            });
    };

    callSearch(){
        if(this.state.filterSelected !== 0 && this.state.searchValue !== '') this.getItens(this.state.page);                        
    }

    onFieldChange(event) {
        this.setState({ [event.target.name]: event.target.value, page:1 });
    }

    closeNotification() {
        this.setState({ openNotification: false });
    }

    deleteItem(data, resolve) {
        const intl = this.props.intl;

        Api2Talk.delete(`/customer/${data.id}`)
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'success',
                        notificationMessage: intl.formatMessage({id:"delete.sucess"}),
                        resultList: []
                    });
                    this.getItens();
                } else {
                    this.fetchDataNotSuccess(result);
                    Api.kickoff(result);
                }
                resolve();
            })
            .catch(err => {
                resolve();
                this.fetchDataThrowError(err);
                Api.kickoff(err);
            });
    };

    async clearFields(){
        this.setState({searchValue: '', page:1, loading: true, filterSelected: 0})

        this.setState({ loading: true });

        const page = 1;
        let url = `/customer/paginate?page=${page}`;
        
        Api2Talk.get(url)
            .then(result => {
                this.setState({ loading: false });
                if (result.data.success) {
                    this.emptyArray = (result.data.data.length === 0) ? true : false ;
                    const count = result.data.count;
                    this.setState({count});
                    this.setPagination(count, page);
                    const formattedList = result.data.data.map(item => {
                        return {...item}
                    });
                    this.setState({ loading: false, resultList: formattedList });
                } else {
                    this.fetchDataNotSuccess(result);
                    Api.kickoff(result);
                }
            })
            .catch(err => {
                this.setState({ loading: false });
                this.fetchDataThrowError(err)
                Api.kickoff(err);
            });
    }

    changeValues = (stateName, value, text = '') => {
        this.setState({
            filterSelected: value
        });
    }

    render() {

        const { classes, headerMenu, actionsHeaderMenu } = this.props;
        const intl = this.props.intl;

        if (Api == null) {
            var lang = this.props.match.params.lang;
            document.location.href = `/${lang}/unavailable`
        }

        return (
          <div className={classes.root} style={{paddingLeft:0, marginLeft:0}}>
            <HeaderMenu />
            <main
                className={clsx(classes.content, {
                    [classes.contentShift]: headerMenu.open,
                }, classes.actionsContent, {
                    [classes.actionscontentShift]: actionsHeaderMenu.open,
                })}
            >
                <div className={classes.drawerHeader} />
                <Container component='main' maxWidth='xl' style={{paddingLeft:0, marginLeft:0}}>
                    
                    {this.state.loading && (
                        <Overlay>
                            <CircularProgress color='secondary' />
                        </Overlay>
                    )}
                    
                    {(!this.emptyArray || this.state.dataFilter) ? (
                        <div>
                            <CssBaseline />
                            <Grid container className={classes.mb20}  spacing={0}>             
                                <Button
                                    variant='contained'
                                    color='secondary'
                                    size='large'
                                    className={classes.button}
                                    startIcon={<AddIcon />}
                                    disabled={!this.context.can('Add', 'Group')}
                                    component={Link} {...{ to: `/${this.props.match.params.lang}/customer-registration` }}
                                >
                                    {<FormattedMessage id="add" />}
                                </Button>
                            </Grid>
 

                            <Grid container spacing={6} alignItems="center" >
                                <Grid item xs={12} sm={12}>
                                    <Card className="background-title-search">
                                        <CardContent>

                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item xs={12} sm={12} md={12} lg={3}>
                                                    <Typography variant="h5">
                                                        {<FormattedMessage id="customer.header" />}
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={6} sm={6} md={4} lg={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <SimpleSelect 
                                                        fullWidth 
                                                        label={intl.formatMessage({ id: "field" })} 
                                                        options={this.state.filters} 
                                                        stateName='filter' 
                                                        changeSelect={this.changeValues} 
                                                        selected={this.state.filterSelected} 
                                                    />
                                                </Grid>
                                                <Grid item xs={6} sm={6} md={4} lg={3}>
                                                    <TextField 
                                                        type="text"
                                                        name="searchValue"
                                                        fullWidth
                                                        value={this.state.searchValue}
                                                        placeholder={intl.formatMessage({ id: "search" })}
                                                        onChange={this.onFieldChange} />
                                                </Grid>
                                                <Grid item xs={1} sm={1} md={1} lg={1}>
                                                    <Button
                                                        variant='contained'
                                                        color='secondary'
                                                        size='large'
                                                        className={classes.button}
                                                        style={{ marginRight: -4 }}
                                                        onClick={this.callSearch}
                                                    >
                                                        <Search />
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={1} sm={1} md={1} lg={1}>
                                                    <Button
                                                        variant='contained'
                                                        color='primary'
                                                        size='large'
                                                        onClick={this.clearFields}
                                                        className={classes.button}

                                                    >
                                                        <ClearIcon />
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>

                            <MyMaterialTable
                                title=""
                                rowClick={(event, rowData) => {  
                                    this.props.addCurrent(rowData);
                                    this.props.history.push(`/${this.props.match.params.lang}/customer-edit`);
                                }}
                                columns={[
                                    { 
                                        title: intl.formatMessage({id:"name"}), 
                                        field: 'name' 
                                    },
                                    { 
                                        title: intl.formatMessage({id:"email"}), 
                                        field: 'email',
                                        render: (row) => {
                                            return (
                                                <span>{(row?.email && row?.email !== "") ? row?.email : "N/A"}</span>
                                            )
                                        }
                                    },
                                    { 
                                        title: intl.formatMessage({id:"phone"}), 
                                        field: 'phone',
                                        render: (row) => {
                                            return (
                                                <span>{(row?.phone && row?.phone !== "") ? row?.phone : "N/A"}</span>
                                            )
                                        }
                                    },
                                ]}
                                data={this.state.resultList}
                                deleteItem={this.deleteItem}                 
                            />

                            <Grid container style={{marginBottom:12,marginTop:8}}>
                                <Grid item xs={12} md={3}>
                                    <Pagination  count={this.state.totalPages} page={this.state.page}  onChange={this.onChangePaginate} />
                                </Grid>
                                <Grid item xs={12} sm={3} style={{marginTop:6}}>
                                    {this.state.pageStart} &nbsp;
                                    {<FormattedMessage id="to" />} &nbsp; 
                                    {this.state.pageEnd} &nbsp;
                                    {<FormattedMessage id="of" />} &nbsp; 
                                    {this.state.count} &nbsp;
                                    {<FormattedMessage id="register" />}
                                </Grid>
                            </Grid>
        
                        </div>)
                    :(
                        <div>
                            <FirstElement
                                title = {intl.formatMessage({id:"customer.list.create.first.customer"})}
                                subtitle = {intl.formatMessage({id:"customer.list.create.customers"})}
                                buttonText = {
                                    <Button
                                    variant='contained'
                                    color='secondary'
                                    size='large'
                                    className={classes.button}
                                    startIcon={<AddIcon />}
                                    component={Link} {...{ to: `/${this.props.match.params.lang}/customer-registration` 
                                }}>
                                {<FormattedMessage id="add" />}
                                </Button>
                                }
                                icon = {<PeopleIcon style={{fontSize: "45px"}} />}
                            />
                        </div>
                    )}

                    {this.state.loading && (
                        <Overlay>
                            <CircularProgress color='secondary' />
                        </Overlay>
                    )}

                    <CustomizedSnackbars
                        variant={this.state.notificationVariant}
                        message={this.state.notificationMessage}
                        isOpen={this.state.openNotification}
                        toClose={this.closeNotification}
                    />
                </Container>
            </main>
            <Footer />   
        </div>
        );
    }
}

CustomerList.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    actionsHeaderMenu: state.actionsHeaderMenu,
    headerMenu: state.headerMenu,
    userSession: state.userSession,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(CustomerList)));

CustomerList.contextType = AbilityContext;